// extracted by mini-css-extract-plugin
export const root = "ProductsContent-module--root--382Sk";
export const triangleFirst = "ProductsContent-module--triangleFirst--vo89J";
export const triangleSecond = "ProductsContent-module--triangleSecond--LiTaH";
export const triangleThird = "ProductsContent-module--triangleThird--3QbB9";
export const row = "ProductsContent-module--row--ZbIKp";
export const link = "ProductsContent-module--link--Qmk1d";
export const header = "ProductsContent-module--header--3-Vzj";
export const content = "ProductsContent-module--content--3dMaS";